import { render, staticRenderFns } from "./AjudaIcon.vue?vue&type=template&id=4c60fa9c&"
import script from "./AjudaIcon.vue?vue&type=script&lang=js&"
export * from "./AjudaIcon.vue?vue&type=script&lang=js&"
import style0 from "./AjudaIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports